import {defineStore} from 'pinia'
import {ref, unref} from 'vue'

/**
 * Page store
 */
export const usePageStore = defineStore('page', () => {

  //Refs
  const title = ref('')

  //Mutators
  const setTitle = value => title.value = unref(value)

  //Expose interface
  return {
    title,
    setTitle,
  }
})
